import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"

const Header = ({ siteTitle }) => (
  <header>
    <div className="px-3 py-0 fade-in-top">
      <h1>
        <Link
          to="/"
        >
          {siteTitle}
        </Link>
      </h1>
      <i className="las la-bars" />
    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header